module.exports = __webpack_public_path__ + "static/media/199.fbcb7903.png";